import {
	InformationsResult,
	GeneralInformationsResult,
	ActivityRiskResult,
	TasksResult
} from '@/core/domain/owas-report';

interface GetResultOWASReportAttributes {
	result: number;
	informations: InformationsResult;
	general_informations: GeneralInformationsResult;
	overall_activity_task: ActivityRiskResult;
	tasks: TasksResult[];
}

export class GetResultOWASReport {
	public readonly result: number;
	public readonly informations: InformationsResult;
	public readonly general_informations: GeneralInformationsResult;
	public readonly overall_activity_task: ActivityRiskResult;
	public readonly tasks: TasksResult[];

	constructor({
		result,
		informations,
		general_informations,
		overall_activity_task,
		tasks = []
	}: GetResultOWASReportAttributes) {
		this.result = result;
		this.informations = informations;
		this.general_informations = general_informations;
		this.overall_activity_task = overall_activity_task;
		this.tasks = tasks;
	}
}
